import './App.css';
import entriesArray from './data';
import AnimalCard from './AnimalCard';
import Select from 'react-select';
import { useState, useCallback } from 'react';
import PopupBar from './PopupBar';


const sortTypes = {
  IncreasingRarity: 'IncreasingRarity',
  DecreasingRarity: 'DecreasingRarity',
  Clade: 'Clade'
};

const options = [
  {value: sortTypes.IncreasingRarity, label: "Increasing rarity"},
  {value: sortTypes.DecreasingRarity, label: "Decreasing rarity"},
  {value: sortTypes.Clade, label: "Class"}
]

function App() {
  const [sort, setSort] = useState(sortTypes.Clade);

  // // Run this code ONCE (when app initially mounts)
  // useState( () => {
  //   console.log("Hello, Digi");
  // }, []);

  const renderCards = useCallback(() => {
    switch(sort) {
      case sortTypes.Clade:
        /* 
          Groups entries by clade, i.e.:
          {
            'amphibian': [Entry, Entry, Entry],
            'mammal': [Entry, Entry]
          }
        */
        const grouped = entriesArray.reduce((acc, item) => {
          acc[item.clade] = [...(acc[item.clade] || []), item];
          return acc;
        }, {});

        return Object.keys(grouped).map((clade) => (
          <>
            <div className="cladeHolder">
              <h2 className="cladeHeader" key={clade}>{clade}</h2>
            </div>
            {grouped[clade].map(value => <AnimalCard data={value} key={value.id}/>)}
          </>
        ))
      case sortTypes.IncreasingRarity:
        /* Sort by least to most rare */ 
        return [...entriesArray]
        .sort((a, b) => (a.rarity - b.rarity))
        .map((value) => <AnimalCard data={value} key={value.id}/>)
      case sortTypes.DecreasingRarity:
        /* Sort by least to most rare */ 
        return [...entriesArray]
        .sort((a, b) => (b.rarity - a.rarity))
        .map((value) => <AnimalCard data={value} key={value.id}/>)
      default:
        return null;
    }
  }, [sort]);

  console.log(entriesArray); // print entries to console

  return (
    <>
    <div class="banner">
      <h1 className="title">Know Your Neighbors</h1>
      <h2 className="subheading">The Unofficial Field Guide to Stanford University Wildlife</h2>
      <PopupBar/> 
    </div>
    <div className="body">
      <div className="select" style={{}}>
        <Select 
          options={options} 
          defaultValue={{value: sortTypes.Clade, label: "Class"}} 
          onChange={(event) => {setSort(event.value)}}
          styles={{
            container: (baseStyles, state) => ({
              ...baseStyles,
              width: 275,
              marginTop: 32,
              marginBottom: 32,
              fontFamily: 'Suez One',
              textTransform: "lowercase",
              textAlign: "right",
              fontSize: '25px',
              backgroundColor: '#606D5D'
            }),
            control: (baseStyles, state) => ({
              ...baseStyles,
              backgroundColor: '#606D5D',
              borderColor: "#C8D5B9"
            }),
            menu: (baseStyles, state) => ({
              ...baseStyles
            }),
            dropdownIndicator: (baseStyles, state) => ({
              ...baseStyles,
              color: "#C8D5B9"
            })           
          }}      
        />
      </div>
      {renderCards()}
    </div>
    </>
  );
}

export default App;
